import { PropsWithChildren } from "react";
import classes from "./index.module.css";
import TooltipIcon, { TooltipIconProps } from "../TooltipIcon";
import { ActionIcon } from "@mantine/core";
import { InfoIcon } from "../TooltipIcon/InfoIcon";

interface InputTooltipProps extends PropsWithChildren {
  wrapperClasses?: string;
  showTooltip?: boolean;
  tooltipProps: TooltipIconProps;
}

export const InputTooltip = ({ wrapperClasses, showTooltip = true, tooltipProps, children }: InputTooltipProps) => {
  return (
    <span className={`${classes.wrapper} ${wrapperClasses}`}>
      <div className={classes.maxWidth} style={!showTooltip ? { width: "100%" } : undefined}>
        {children}
      </div>
      {showTooltip && <TooltipIcon className={classes.helper} {...tooltipProps} />}
    </span>
  );
};

interface InputClickableIconProps extends PropsWithChildren {
  wrapperClasses?: string;
  size?: number;
  onClick: () => void;
}

export const InputClickableIcon = ({ wrapperClasses, children, size = 20, onClick }: InputClickableIconProps) => {
  return (
    <span className={`${classes.wrapper} ${wrapperClasses}`}>
      <div className={classes.maxWidth}>{children}</div>
      <ActionIcon className={classes.helper} variant="white" aria-label="info" onClick={onClick}>
        <InfoIcon size={size} />
      </ActionIcon>
    </span>
  );
};
